<mat-form-field [class.multi-line]="multiline" [class.is-wide]="maxLength > 30">
  <input
    *ngIf="!multiline"
    matInput
    [disabled]="isDisabled"
    [dir]="textDirection"
    type="text"
    [placeholder]="placeholder"
    [(ngModel)]="value"
    (ngModelChange)="propagateChange($event)"
    [maxLength]="maxLength"
    [attr.data-testid]="testId"
    [readonly]="readonly"
  />
  <textarea
    *ngIf="multiline"
    [disabled]="isDisabled"
    matInput
    [placeholder]="placeholder"
    [(ngModel)]="value"
    (ngModelChange)="propagateChange($event)"
    [maxLength]="maxLength"
    rows="3"
    [dir]="textDirection"
    [attr.data-testid]="testId"
    [readonly]="readonly"
  ></textarea>
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <mat-hint>{{ value?.length || 0 }} / {{ maxLength }}</mat-hint>
</mat-form-field>
